import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { detectIconById, getCookie } from '../common/enum';
import { dataGame, gameResultGeneral, gameResultOuting, gameAnalytics } from './data';
import axios from '../axios';
import {numeralFormat} from '../common/numeralFormat';
const ACTIONS_GAMES = {
    GET_INFO_GAME_ID_SUCCESS: 'GET_INFO_GAME_ID_SUCCESS',
    GET_INFO_GAME_ID_ERROR: 'GET_INFO_GAME_ID_ERROR',
    GET_INFO_GAMES_SUCCESS: 'GET_INFO_GAMES_SUCCESS',
    GET_INFO_GAMES_ERROR: 'GET_INFO_GAMES_ERROR',
    GET_INFO_DETAIL_GAMES_SUCCESS: 'GET_INFO_DETAIL_GAMES_SUCCESS',
    GET_INFO_DETAIL_GAMES_ERROR: 'GET_INFO_DETAIL_GAMES_ERROR',
    GET_GAME_RESULT_GENERAL_SUCCESS: 'GET_GAME_RESULT_GENERAL_SUCCESS',
    GET_GAME_RESULT_GENERAL_ERROR: 'GET_GAME_RESULT_GENERAL_ERROR',
    GET_GAME_RESULT_OUTTING_SUCCESS: 'GET_GAME_RESULT_OUTTING_SUCCESS',
    GET_GAME_RESULT_OUTTING_ERROR: 'GET_GAME_RESULT_OUTTING_ERROR',
    GET_GAME_ANALYTICS_SUCCESS: 'GET_GAME_ANALYTICS_SUCCESS',
    GET_GAME_ANALYTICS_ERROR: 'GET_GAME_ANALYTICS_ERROR',
    GET_GAME_RESULT_INNINGS_SUCCESS: 'GET_GAME_RESULT_INNINGS_SUCCESS',
    GET_GAME_RESULT_INNINGS_ERROR: 'GET_GAME_RESULT_INNINGS_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getInfoGame = (game_id) => {

    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/${game_id}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_GAME_ID_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_GAME_ID_ERROR, err));
            });
    };
};

const addPitcherPlayer = ({playerId, teamId, gameId}) => {
    return () => {

        return axios.post(`api/games/${gameId}/starting_pitchers/${teamId}`, {
            player_id: playerId,
        });
    }
}

const getInfoMatchInGame = (data) => {

    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/${data.game_id}/analytics/${data.team_id}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_GAMES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_GAMES_ERROR, err));
            });
    };
};

// const getInfoDetailGame = (id) => {
//     const config = {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
//         },
//     };
//     let url = `${host.serverTest}api/games/${id}/analytics/starting_pitchers`;
//     return (dispatch) => {
//         callApi(url, config,
//             (data) => {
//                 dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_DETAIL_GAMES_SUCCESS, data));
//             },
//             (err) => {
//                 dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_DETAIL_GAMES_ERROR, err));
//             });
//     };
// };

const getGameResultGeneral = (game_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/${game_id}/results/general`;

    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error) {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_ERROR, err));
            });
    };
}

const getGameResultOutting = (game_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/${game_id}/results/outings`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                console.log(data);

                if (data.error) {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_ERROR, err));
            });
    };
}

const getGameResultInnings = (game_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/games/${game_id}/results/innings`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error) {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_ERROR, err));
            });
    };
}


const getGameAnalytics = (game_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // game_id
    let url = `${host.serverTest}api/games/${game_id}/analytics/starting_pitchers`;

    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error || data.length === 0) {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_ANALYTICS_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_ANALYTICS_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_GAMES.GET_GAME_ANALYTICS_ERROR, err));
            });
    };
}

// const getInfoPitcherGame = (id) => {
//     const config = {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
//         },
//     };
//     let url = `${host.serverTest}api/teams/${id}/pitchers`;
//     return (dispatch) => {
//         callApi(url, config,
//             (data) => {
//                 console.log({ data });
//                 dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_PITCHERS_GAMES_SUCCESS, data));
//             },
//             (err) => {
//                 console.log(err);
//                 dispatch(updateStatus(ACTIONS_GAMES.GET_INFO_PITCHERS_GAMES_ERROR, err));
//             });
//     };
// };

const converDataDetailGames = (data) => {
    if (data) {
        const arr = data.opponent_batters.map(items => {
            return {
                item: [
                    {
                        text: items.player_name,
                        img: detectIconById(data.pitcher.team.id)
                    },
                    { text: numeralFormat(items.avg, 3) },//被打率
                    { text: items.ab },//打数
                    { text: items.h },//被安打
                    { text: items.hr },//被本塁打
                    { text: items.so },//奪三振
                    { text: items.bb },//与四球
                    { text: items.hbp },//与死球
                ]
            }
        });
        return arr;
    }
}

// convert
const convertInfoMatchInGame = (data) => {
    if (data) {
        const arr = data.map(items => {
            return {
                item: [
                    { text: items.g },
                    { text: items.w },
                    { text: items.l },
                    { text: items.t },
                    { text: items.r },
                    { text: items.r2 },
                    { text: items.h },
                    { text: items.hr },
                    { text: items.so },
                    { text: items.bb },
                    { text: items.hbp },
                    { text: items.gidp },
                    { text: items.sb },
                    { text: items.e },
                    { text: numeralFormat(items.avg, 3)},
                    { text: items.era }
                ]
            }
        });
        return arr;
    }
};

// convert
const convertInfoMatchInGame3 = (data) => {
    if (data) {
        const arr = data.map(items => {
            const pitchers = items.responsible_pitchers ? items.responsible_pitchers.reduce((prev, current, index, array) => {
                return ((prev) ? prev + ',　' : prev) + current.w_l_sv_type_name + ':' + current.player.player_name;
            }, '') : '';
            return {
                item: [

                    { text: items.game_date },
                    { text: items.w_l_type_name },
                    { text: (items.away_team_score || items.home_team_score) ? `${items.away_team_score} - ${items.home_team_score}` : '' },
                    { text: items.starting_pitcher.player_name },
                    { text: pitchers },
                    { text: items.stadium_name },
                    { text: items.game_started_hm }
                ]
            }
        });
        return arr;
    }

}

// convert
const convertGameResultGeneral1 = (items) => {

    if (items) {
        const arr = [
            {
                item: [
                    { text: items.detail && items.detail.attendance ? items.detail.attendance : '-' },
                    { text: items.detail && items.detail.game_time ? items.detail.game_time : '-' },
                ]
            }
        ];
        return arr;
    }
}

// convert
const convertHeaderGameResultGeneral2 = (items) => {
    let arr = [];
    if (items.umpires) {
        arr = items.umpires.map(val => {
            return val.umpire_type_name;
        })
        return arr;
    }
    return arr;
}

// convert
const convertGameResultGeneral2 = (items) => {
    let arr = [];
    if (items.umpires) {
        arr = items.umpires.map(val => {
            return {text: val.umpire ? val.umpire.umpire_name : '-'}
        })
        return [{item:arr}];
    }
    return arr;
}

const convertGameAnalytics = (data) => {
    if (data && data.opponent_batters) {
        const arr = data.opponent_batters.map(items => {
            return {
                item: [
                    {
                        text: items.player_name,
                        img: detectIconById(items.team_id),
                        url: '/player/' + items.player_id,
                    },
                    { text: numeralFormat(items.avg, 3) },//被打率
                    { text: items.ab },//打数
                    { text: items.h },//被安打
                    { text: items.hr },//被本塁打
                    { text: items.so },//奪三振
                    { text: items.bb },//与四球
                    { text: items.hbp },//与死球
                ]
            }
        });
        return arr;
    }
}

// convert
// const convertGameResultOutting = (items) => {
//     let arr = [];
//     if (items) {
//         arr = items.umpires.map((val, i) => {
//             return {
//                 item: {}
//             }
//         })
//         return arr;
//     }
//     return arr;
// }

export {
    ACTIONS_GAMES, getInfoMatchInGame, convertInfoMatchInGame3, convertInfoMatchInGame, converDataDetailGames,
    getGameResultGeneral, convertGameResultGeneral1, convertHeaderGameResultGeneral2, convertGameResultGeneral2,
    getGameResultOutting, getGameAnalytics, convertGameAnalytics, getGameResultInnings,
    getInfoGame, addPitcherPlayer,
    // getInfoDetailGame
};
